import $ from "jquery";
import "datatables.net";
import "datatables.net-dt";

export default function initObjectsTable() {
  $(document).ready(function () {
    const table = $(".objects-table").DataTable({
      paging: false,
      // searching: false,
      stateSave: true,
      scrollX: true,
      order: [[1, "asc"]],
      aoColumnDefs: [{ iDataSort: 0, aTargets: [1] }],
      drawCallback: function (settings) {
        function initDesktopFunctions() {
          const lrgScreens = window.matchMedia("(min-width: 768px)");

          lrgScreens.addListener(handleScreenChange);

          function handleScreenChange(e) {
            if (e.matches) {
              $(".apartment").on("mouseenter touchstart", function () {
                const id = $(this).attr("id");

                $(".objects-table tr[data-id='" + id + "']").addClass(
                  "rowHover"
                );

                // apartment info
                document
                  .querySelector(`.apartment-info[info-id='${id}']`)
                  .classList.remove("hidden");
              });

              $(".apartment").on("mouseleave touchend", function () {
                const id = $(this).attr("id");

                $(".objects-table tr[data-id='" + id + "']").removeClass(
                  "rowHover"
                );

                // apartment info
                document
                  .querySelector(`.apartment-info[info-id='${id}']`)
                  .classList.add("hidden");
              });
            }
          }

          // Run it initially
          handleScreenChange(lrgScreens);
        }

        initDesktopFunctions();
      },
    });

    table.columns([0]).visible(false, false);
    table.columns.adjust().draw(false); // adjust column sizing and redraw

    table.on("click", "tbody tr", function () {
      // if apartment is not sold
      if (
        $(this).attr("data-status") !== "sold"
        // && $(this).attr("data-status") !== "reserved"
      ) {
        window.location.href = $(this).attr("data-url");
      }
    });
  });
}
